import { render, staticRenderFns } from "./ratifyAccord.vue?vue&type=template&id=41e182dd&scoped=true"
import script from "./ratifyAccord.vue?vue&type=script&lang=js"
export * from "./ratifyAccord.vue?vue&type=script&lang=js"
import style0 from "./ratifyAccord.vue?vue&type=style&index=0&id=41e182dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e182dd",
  null
  
)

export default component.exports